var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("sdz-modal", {
        ref: "sdzModalRef",
        attrs: {
          width: "450",
          title: "Excluir rateio",
          text: "Você realmente deseja excluir este rateio?",
          "buttons-position": "right",
          "confirm-button-label": "Excluir",
          "confirm-button-background-color": "red",
        },
        on: { confirm: _vm.onConfirm, close: _vm.close },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }